const configErrors = {
  'user.firstName': {
    firstName: 'errors.firstNameIsNotMatchPattern',
  },
  firstName: {
    firstName: 'errors.firstNameIsNotMatchPattern',
  },
  'user.lastName': {
    lastName: 'errors.lastNameIsNotMatchPattern',
  },
  lastName: {
    lastName: 'errors.lastNameIsNotMatchPattern',
  },
  'admin.canHaveOnlyOneStation': {
    email: 'errors.emailExisting',
  },
  'user.emailAlreadyInUse': {
    email: 'errors.emailExisting',
  },
  'user.emailReserved': {
    email: 'errors.emailReserved',
  },
};

export default configErrors;
